import { createClient } from "@supabase/supabase-js";
import { envValue } from "./env";

const SUPABASE_URL = envValue(import.meta.env.VITE_SUPABASE_URL);
const SUPABASE_ANON_KEY = envValue(import.meta.env.VITE_SUPABASE_ANON_KEY);

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
});
